var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.793 15.754L11.301 2.749a1.434 1.434 0 00-.54-.547 1.518 1.518 0 00-1.516 0 1.434 1.434 0 00-.541.547L1.207 15.754a1.453 1.453 0 00-.011 1.473c.13.226.32.415.549.55.229.136.49.213.76.223h14.989c.269-.01.531-.087.76-.222.23-.135.419-.325.55-.55a1.452 1.452 0 00-.011-1.474zm-8.794-2.692a1.5 1.5 0 011.03.434c.27.27.417.63.408 1.004.009.373-.138.734-.408 1.004a1.5 1.5 0 01-1.03.433 1.5 1.5 0 01-1.029-.434c-.269-.27-.416-.63-.407-1.003a1.376 1.376 0 01.407-1.004 1.5 1.5 0 011.03-.434zm-1.363-5.17a.355.355 0 01.099-.273.385.385 0 01.275-.121h1.98a.4.4 0 01.275.12.367.367 0 01.1.275l-.232 4.252a.362.362 0 01-.114.248.394.394 0 01-.26.107H9.245a.394.394 0 01-.26-.107.362.362 0 01-.114-.248l-.235-4.252z",
    fill: "#0D2976"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default ForwardRef;